import { takeLatest } from 'redux-saga/effects';
import {
  getAccessGroupListSuccess, getAccessGroupListFail,
  getAccessGroupDetailsSuccess, getAccessGroupDetailsFail
} from './accessGroupState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/security/access-groups');
const redirectData = {route:'/console/access-groups', mode: 'list', recordId:0 };
const modelName = 'Access Group';
const modelId = 'acg_id';

function* getAccessGroupList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getAccessGroupListSuccess, 
		getAccessGroupListFail,
		null, null, LOADING_MSG);
}

function* getAccessGroupDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getAccessGroupDetailsSuccess, 
		getAccessGroupDetailsFail,
		null, null, LOADING_MSG);		
}

function* doAccessGroupCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getAccessGroupDetailsSuccess, 
		getAccessGroupDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doAccessGroupUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getAccessGroupDetailsSuccess, 
		getAccessGroupDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doAccessGroupDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getAccessGroupDetailsSuccess, 
		getAccessGroupDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* accessGroupSaga() {
  yield takeLatest('accessGroup/getAccessGroupList', getAccessGroupList);
  yield takeLatest('accessGroup/getAccessGroupDetails', getAccessGroupDetails);
  yield takeLatest('accessGroup/doAccessGroupCreate', doAccessGroupCreate);
  yield takeLatest('accessGroup/doAccessGroupUpdate', doAccessGroupUpdate);
  yield takeLatest('accessGroup/doAccessGroupDelete', doAccessGroupDelete);  
}

export default accessGroupSaga;
